import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from "react-router-dom";
import AuthContextProvider, {AuthContext} from "./context/AuthContext";
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <Router>
       <React.StrictMode>
    <AuthContextProvider>
    <App />
    </AuthContextProvider>
  </React.StrictMode>
    </Router>
);

reportWebVitals();
